<template>
    <section v-if="json" class="page-news">
        <div class="news-top" data-aos="custom-fade-in" >
            <div class="capper">
                <div class="capper-padded-4x">
                    <div class="back-to-blogs">
                        <router-link class="txta" :to="'/community#all-blogs'" aria-label="Back to Blogs">
                            <span class="arrow"><ArrowLeft/></span>
                            <span class="txt">BACK TO BLOGS</span>
                        </router-link>
                    </div>
                    <img v-if="json.featuredNewsImage?.[0]?.url" :alt="json.featuredNewsImage?.[0]?.title" :src="json.featuredNewsImage?.[0]?.url">
                    <h1>{{json.title}}</h1>
                </div>
            </div>
        </div>
        <ContentBlocks :json="json" />
    </section>
</template>
<script>
import axios from 'axios'
import ContentBlocks from '@/components/blocks/ContentBlocks'
import gh from '@/helpers/gh'
import ArrowLeft from "@/components/svgs/ArrowLeft.vue";
export default {
    name: "NewsPage",
    components: {
        ArrowLeft,
        ContentBlocks,
    },
    data () {
        return {
            window: window,
            json: null,
            transition: false,
        }

    },
    created () {
    },
    mounted () {
        let slug = this.$route.fullPath
        slug = gh.stripSlashesFrontAndBack(slug)
        const turl = gh.formatFeedUrl(slug)
        axios.get((turl))
            .then((res) => {
                this.json = res.data
                this.reveal()
            }).catch((e) => {
                console.error('Error',slug,e)
        })
    },
    methods: {
        reveal () {

        },
        unreveal () {

        },
    }
}
</script>
